module.exports = __webpack_public_path__ + "img/dry-dirt-transition.5ee15b41.png";